export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set(["favicon.png","logo.png","logo_sm.png","splashlogo.png"]),
	mimeTypes: {".png":"image/png"},
	_: {
		client: {start:"_app/immutable/entry/start.BwBDE_w0.js",app:"_app/immutable/entry/app.B-o11apP.js",imports:["_app/immutable/entry/start.BwBDE_w0.js","_app/immutable/chunks/BwpWoHbM.js","_app/immutable/chunks/mtF927Wn.js","_app/immutable/chunks/DC8ybcx3.js","_app/immutable/entry/app.B-o11apP.js","_app/immutable/chunks/C1FmrZbK.js","_app/immutable/chunks/mtF927Wn.js","_app/immutable/chunks/IHki7fMi.js"],stylesheets:[],fonts:[],uses_env_dynamic_public:false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/2.js')),
			__memo(() => import('./nodes/3.js')),
			__memo(() => import('./nodes/4.js')),
			__memo(() => import('./nodes/5.js')),
			__memo(() => import('./nodes/6.js')),
			__memo(() => import('./nodes/7.js')),
			__memo(() => import('./nodes/8.js')),
			__memo(() => import('./nodes/9.js')),
			__memo(() => import('./nodes/10.js')),
			__memo(() => import('./nodes/11.js')),
			__memo(() => import('./nodes/12.js'))
		],
		routes: [
			{
				id: "/",
				pattern: /^\/$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 3 },
				endpoint: null
			},
			{
				id: "/api/auth/login",
				pattern: /^\/api\/auth\/login\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/auth/login/_server.ts.js'))
			},
			{
				id: "/api/codex-auth",
				pattern: /^\/api\/codex-auth\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/codex-auth/_server.ts.js'))
			},
			{
				id: "/api/custom-panels/code/[id]",
				pattern: /^\/api\/custom-panels\/code\/([^/]+?)\/?$/,
				params: [{"name":"id","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/custom-panels/code/_id_/_server.ts.js'))
			},
			{
				id: "/api/custom-panels/create",
				pattern: /^\/api\/custom-panels\/create\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/custom-panels/create/_server.ts.js'))
			},
			{
				id: "/api/custom-panels/delete",
				pattern: /^\/api\/custom-panels\/delete\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/custom-panels/delete/_server.ts.js'))
			},
			{
				id: "/api/custom-panels/export/[id]",
				pattern: /^\/api\/custom-panels\/export\/([^/]+?)\/?$/,
				params: [{"name":"id","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/custom-panels/export/_id_/_server.ts.js'))
			},
			{
				id: "/api/custom-panels/import",
				pattern: /^\/api\/custom-panels\/import\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/custom-panels/import/_server.ts.js'))
			},
			{
				id: "/api/custom-panels/list",
				pattern: /^\/api\/custom-panels\/list\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/custom-panels/list/_server.ts.js'))
			},
			{
				id: "/api/custom-panels/load",
				pattern: /^\/api\/custom-panels\/load\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/custom-panels/load/_server.ts.js'))
			},
			{
				id: "/api/custom-panels/metadata/[id]",
				pattern: /^\/api\/custom-panels\/metadata\/([^/]+?)\/?$/,
				params: [{"name":"id","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/custom-panels/metadata/_id_/_server.ts.js'))
			},
			{
				id: "/api/custom-panels/morph",
				pattern: /^\/api\/custom-panels\/morph\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/custom-panels/morph/_server.ts.js'))
			},
			{
				id: "/api/custom-panels/update-code",
				pattern: /^\/api\/custom-panels\/update-code\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/custom-panels/update-code/_server.ts.js'))
			},
			{
				id: "/api/custom-panels/watch",
				pattern: /^\/api\/custom-panels\/watch\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/custom-panels/watch/_server.ts.js'))
			},
			{
				id: "/api/files",
				pattern: /^\/api\/files\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/files/_server.ts.js'))
			},
			{
				id: "/api/files/create",
				pattern: /^\/api\/files\/create\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/files/create/_server.ts.js'))
			},
			{
				id: "/api/files/delete",
				pattern: /^\/api\/files\/delete\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/files/delete/_server.ts.js'))
			},
			{
				id: "/api/files/list",
				pattern: /^\/api\/files\/list\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/files/list/_server.ts.js'))
			},
			{
				id: "/api/files/read",
				pattern: /^\/api\/files\/read\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/files/read/_server.ts.js'))
			},
			{
				id: "/api/files/rename",
				pattern: /^\/api\/files\/rename\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/files/rename/_server.ts.js'))
			},
			{
				id: "/api/files/upload",
				pattern: /^\/api\/files\/upload\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/files/upload/_server.ts.js'))
			},
			{
				id: "/api/files/write",
				pattern: /^\/api\/files\/write\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/files/write/_server.ts.js'))
			},
			{
				id: "/api/git/checkout",
				pattern: /^\/api\/git\/checkout\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/git/checkout/_server.ts.js'))
			},
			{
				id: "/api/git/commits",
				pattern: /^\/api\/git\/commits\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/git/commits/_server.ts.js'))
			},
			{
				id: "/api/git/commit",
				pattern: /^\/api\/git\/commit\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/git/commit/_server.ts.js'))
			},
			{
				id: "/api/git/discard",
				pattern: /^\/api\/git\/discard\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/git/discard/_server.ts.js'))
			},
			{
				id: "/api/git/pull",
				pattern: /^\/api\/git\/pull\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/git/pull/_server.ts.js'))
			},
			{
				id: "/api/git/push",
				pattern: /^\/api\/git\/push\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/git/push/_server.ts.js'))
			},
			{
				id: "/api/git/stage",
				pattern: /^\/api\/git\/stage\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/git/stage/_server.ts.js'))
			},
			{
				id: "/api/git/status",
				pattern: /^\/api\/git\/status\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/git/status/_server.ts.js'))
			},
			{
				id: "/api/git/unstage",
				pattern: /^\/api\/git\/unstage\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/git/unstage/_server.ts.js'))
			},
			{
				id: "/api/log/browser",
				pattern: /^\/api\/log\/browser\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/log/browser/_server.ts.js'))
			},
			{
				id: "/api/panels/layout",
				pattern: /^\/api\/panels\/layout\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/panels/layout/_server.ts.js'))
			},
			{
				id: "/api/sessions",
				pattern: /^\/api\/sessions\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/sessions/_server.ts.js'))
			},
			{
				id: "/api/tasks/npm-scripts",
				pattern: /^\/api\/tasks\/npm-scripts\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/tasks/npm-scripts/_server.ts.js'))
			},
			{
				id: "/api/tasks/output/[id]",
				pattern: /^\/api\/tasks\/output\/([^/]+?)\/?$/,
				params: [{"name":"id","optional":false,"rest":false,"chained":false}],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/tasks/output/_id_/_server.ts.js'))
			},
			{
				id: "/api/tasks/run",
				pattern: /^\/api\/tasks\/run\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/tasks/run/_server.ts.js'))
			},
			{
				id: "/api/tasks/stop",
				pattern: /^\/api\/tasks\/stop\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/tasks/stop/_server.ts.js'))
			},
			{
				id: "/api/version",
				pattern: /^\/api\/version\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/version/_server.ts.js'))
			},
			{
				id: "/api/ws",
				pattern: /^\/api\/ws\/?$/,
				params: [],
				page: null,
				endpoint: __memo(() => import('./entries/endpoints/api/ws/_server.ts.js'))
			},
			{
				id: "/docs",
				pattern: /^\/docs\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 4 },
				endpoint: null
			},
			{
				id: "/docs/api-reference/overview",
				pattern: /^\/docs\/api-reference\/overview\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 6 },
				endpoint: null
			},
			{
				id: "/docs/getting-started/installation",
				pattern: /^\/docs\/getting-started\/installation\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 7 },
				endpoint: null
			},
			{
				id: "/docs/user-guide/custom-panels",
				pattern: /^\/docs\/user-guide\/custom-panels\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 8 },
				endpoint: null
			},
			{
				id: "/docs/user-guide/keyboard-shortcuts",
				pattern: /^\/docs\/user-guide\/keyboard-shortcuts\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 9 },
				endpoint: null
			},
			{
				id: "/docs/user-guide/mobile-usage",
				pattern: /^\/docs\/user-guide\/mobile-usage\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 10 },
				endpoint: null
			},
			{
				id: "/docs/user-guide/terminal-persistence",
				pattern: /^\/docs\/user-guide\/terminal-persistence\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 11 },
				endpoint: null
			},
			{
				id: "/docs/[...slug]",
				pattern: /^\/docs(?:\/(.*))?\/?$/,
				params: [{"name":"slug","optional":false,"rest":true,"chained":true}],
				page: { layouts: [0,2,], errors: [1,,], leaf: 5 },
				endpoint: null
			},
			{
				id: "/login",
				pattern: /^\/login\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 12 },
				endpoint: null
			}
		],
		prerendered_routes: new Set([]),
		matchers: async () => {
			
			return {  };
		},
		server_assets: {}
	}
}
})();

export const prerendered = new Set([]);

export const base = "";